import { call, cancel, fork, put, takeEvery } from 'redux-saga/effects';
import { delay } from 'redux-saga';

/**
 * Example
 *
 * let id = {
 *   posts: { 4: true, 7: true, 345: true },
 *   authors: { 23: true, 47: true, 78: true },
 * }
 */
const ids = {};
const tasks = {};

function* fetchReference(payload) {
    const { resource, type } = payload;

    // Combined with cancel(), this debounces the calls
    yield call(delay, 50);

    const params = {
        id: Object.keys(ids[resource]),
        size: 24,
    };

    yield put({
        type: type,
        payload: {
            params: params,
        },
    });

    // Delete the key from the object.
    delete ids[resource];
    delete tasks[resource];
}

function* accumulate({ payload }) {
    const { id, resource } = payload;

    if (!ids[resource]) {
        ids[resource] = {};
    }

    ids[resource][id] = true;

    if (tasks[resource]) {
        yield cancel(tasks[resource]);
    }

    tasks[resource] = yield fork(fetchReference, payload);
}

export default function* accumulateSagas() {
    yield [
        takeEvery('FETCH_ACCOUNT_ACCUMULATED', accumulate),
        takeEvery('FETCH_BOOKING_ACCUMULATED', accumulate),
        takeEvery('FETCH_CAMPAIGN_ACCUMULATED', accumulate),
        takeEvery('FETCH_CATEGORY_ACCUMULATED', accumulate),
        takeEvery('FETCH_PRODUCT_ACCUMULATED', accumulate),
        takeEvery('FETCH_PROPERTYGROUP_ACCUMULATED', accumulate),
        takeEvery('FETCH_USER_ACCUMULATED', accumulate),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/accumulateSagas.js